import { useMemoizedFn } from 'ahooks';
import { notification } from 'tea-component';
import useCOS from '@gp/hooks/useCos/useCOS';
import { getBIDSTencentQCouldMassage } from '@gp/services/global';
import { queryMeetingsFilePreviewPermissionOfManagement } from '@gp/pages/StudioDashboard/StudioOverall/services/studioOverallDetail';
import { getFileInfoByUrl, isSafari, isImageWithSuffix, isFilePreviewableByCOSWithSuffix } from '@gp/utils/common';
import { UPLOAD_FOLDER_NAME_MAP } from '@gp/constants/const';
import { ENV } from '@home/_config/config';

export default function useAttachmentPreview(studioId: string) {
  // 全球加速，预发布和正式
  const controlledEnv = ['pre', 'pro'];
  const isUseAccelerate = controlledEnv.includes(ENV);

  const uploadFolderName = UPLOAD_FOLDER_NAME_MAP.studioMeetingFile;

  const { getObjectUrl, getImagePreviewUrl, getDocumentPreviewUrl } = useCOS({
    // 仅预发布、正式 支持COS全球域名加速请求
    useAccelerate: isUseAccelerate,
    baseCOSConfigFetcher: () => getBIDSTencentQCouldMassage(uploadFolderName),
    authorizationFetcher: (_options?: any) => getBIDSTencentQCouldMassage(uploadFolderName),
  });

  const getPreviewUrl = useMemoizedFn(async (path: string): Promise<string> => {
    const { fileSuffix } = getFileInfoByUrl(path);
    let url = '';
    if (isFilePreviewableByCOSWithSuffix(fileSuffix)) {
      const res = await getDocumentPreviewUrl({
        key: path,
      });
      url = res?.url || '';
    } else if (isImageWithSuffix(fileSuffix)) {
      const res = await getImagePreviewUrl({
        key: path,
      });
      url = res?.url || '';
    } else {
      const res = await getObjectUrl({
        key: path,
      });
      url = res?.url || '';
    }
    return url;
  });

  const handleAttachmentPreview = useMemoizedFn<IStudioManagementMeetingAttachmentActionHandler>(
    async (meeting, attachment) => {
      try {
        const hasPreviewPermission = await queryMeetingsFilePreviewPermissionOfManagement({
          studio_id: studioId,
        });
        if (!hasPreviewPermission) {
          notification.warning({
            className: 'dbg-notification',
            style: { fontSize: 14 },
            unique: true,
            description: 'Permission has been updated. Please refresh the page and try again',
          });
          return;
        }
        if (isSafari()) {
          const page = window.open('', '_blank');
          const url = await getPreviewUrl(attachment?.filePath || '');
          if (page) {
            page.location = url;
          }
        } else {
          const url = await getPreviewUrl(attachment?.filePath || '');
          window.open(url);
        }
      } catch (exception) {
        console.warn(exception);
      }
    },
  );

  return {
    onAttachmentPreview: handleAttachmentPreview,
  };
}
